var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":"500"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('ThirtyDay',{attrs:{"bizId":_vm.bizId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }